

const roundToDecimalPlace = (data,place) => {
    return Number(data.toFixed(place))
}

export default roundToDecimalPlace